import { Box, Stack } from '@ltvco/refresh-lib/theme';

import { AstrologyHeaderLight } from '../AstrologyHeaders/AstrologyHeaderLight';
import { UserProps } from '../interfaces';

import { AstrologyOnboardingForm } from './AstrologyOnboardingForm/AstrologyOnboardingForm';

interface AstrologyOnboardingProps {
  // eslint-disable-next-line no-unused-vars
  onSubmitCallback: (astrologyUser: UserProps | null) => void;
}

export const AstrologyOnboarding = ({
  onSubmitCallback,
}: AstrologyOnboardingProps) => {
  return (
    <Stack
      alignItems="center"
      p={4.5}
      direction={{ xs: 'column', md: 'row' }}
      width="100%"
    >
      <Box minWidth="50%" px={{ sx: 0, md: 8 }}>
        <AstrologyHeaderLight />
      </Box>
      <AstrologyOnboardingForm onSubmitCallback={onSubmitCallback} />
    </Stack>
  );
};
